import { EnrolService } from './../../_services/enrol.service';

import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { AuthService } from './../../_services/auth.service';
import { StudentService } from './../../_services/student.service';

import { EnrolmentRequestInformation } from 'src/app/_models/EnrolmentRequestInformation';
import { Guardian } from 'src/app/_models/guardian';
import { SettlementChoiceData } from 'src/app/_models/payments/SettlementChoiceData';
import { StudentRegData } from 'src/app/_models/registration/StudentRegData';
import { ResultData } from 'src/app/_models/ResultData';
import { Subscription } from 'src/app/_models/subscription';
import { CountryService } from 'src/app/_services/country.service';
import { LevelService } from 'src/app/_services/level.service';
import { SubjectService } from 'src/app/_services/subject.service';



@Component({
  selector: 'app-enrol-trial',
  templateUrl: './enrol-trial.component.html',
  styleUrls: ['./enrol-trial.component.css']
})
export class EnrolTrialComponent implements OnInit {
  title = 'Premium';

  user_id: number = undefined
  myForm;
  errorSaving = false
  @Input() studentDetail: any = {}
  @Input() guardian = new Guardian()
  @Output() enrolLoading = new EventEmitter<boolean>()
  @Output() closeModalRequest = new EventEmitter<string>()
  @Output() provisioning = new EventEmitter<boolean>()
  countries = []
  levels = []
  subscriptionChoices = []
  subjects = []
  curriculums = []
  showButtons = false
  paymentOrderId: string
  invoiceId: string

  paymentData = { amount: 0 }
  constructor(
    private studentService: StudentService,
    private authService: AuthService,
    private countryService:CountryService,
    private levelService:LevelService,
    private subjectService:SubjectService,
    private router: Router,
    private enrolService: EnrolService
  ) { }
  get f() {
    return this.myForm.controls
  }

  ngOnInit(): void {
    this.user_id = this.authService.gatePass.getValue().user_id
    this.errorSaving = false
    this.myForm = new FormGroup({
      country: new FormControl("", [Validators.required]),
      curriculum: new FormControl("", [Validators.required]),
      level: new FormControl("", [Validators.required]),

      coupon: new FormControl("", [Validators.required])
    });
    this.countryService.getCountriesIdAndName().subscribe(
      x => { this.countries = x }
    )
    this.levelService.getCurriculums().subscribe(
      {next:(data:ResultData)=>{this.curriculums= data.rs.data },error:(err)=>{console.log("error getting curiculums",err)}
    })
  }
  on_submit() {
    this.enrolLoading.emit(true)
    this.paymentOrderId = this.studentService.generatePaymentOrderId()
    let subscription = new Subscription()
    let requests: Array<StudentRegData> = []
    for (let i = 0; i < this.subjects.length; i++) {
      let dd = this.enrolService.formatData(this.myForm.value, this.studentDetail, this.subjects[i].id,subscription,"new_trial")
      requests.push(dd)
    }
    let eInfo = new EnrolmentRequestInformation()
    eInfo.requests = requests
    eInfo.server_guardian_id = this.studentDetail.server_guardian_id
    eInfo.server_country_id=this.studentDetail.server_country_id
    let settlementChoice = new SettlementChoiceData()

    settlementChoice.payment_info.paymentOrderId=this.paymentOrderId


    eInfo.settlement_choice=settlementChoice

    this.studentService.enrolSave(eInfo).subscribe(
      { next: (data:ResultData)=>{
        let invoiceData = data.rs.data
        this.invoiceId = invoiceData.server_enrolment_id
        if (invoiceData.id != 0) {
          this.router.navigate(['/student/show', this.studentDetail.server_user_id])
        }
        this.closeModal()
      },
      error:(err)=>{
        console.error('Error sending POST request:', err);
      }
    }
    );

  }
  closeModal() {
    this.closeModalRequest.emit("myTrialEnrolmentModal")
  }

  onCurriculumOptionsSelected(value: number) {

    this.levelService.getLevelIdAndNameByCurriculum(value).subscribe(
   {next:(data:ResultData)=>{
    this.levels = data.rs.data
   },error:(err)=>{
    console.error("Error Retrieving Level and name By Country", err)
   }

      }
    )
  }
  onLevelOptionsSelected(value: number) {

    this.subjectService.getSubjectsIdAndNameByLevel(value).subscribe(
      {next:(data:ResultData)=>{
        this.subjects = data.rs.data
      },error:(err)=>{
        console.error("Error retrieving subject by level",err)
      }
      }
    )
  }

  onShowPaymentModes() {
    this.showButtons = true
  }


  redirectOTP(data) {
    var link = data.link
    window.location.href = link
  }
  timer(ms) {
    return new Promise(res => setTimeout(res, ms));
  }

  somethingWentWrong() {
    Swal.fire('Oops', "Some thing went wrong. Contact boldungu team for assistance", 'info');
  }




}










